module.exports = __webpack_public_path__ + "img/nc_yeni.b15b8b3f.png";